import React from 'react';

export const withField = (Component) =>{
  const WithFieldComponent = ({field, form, meta, ...props}) => (
    <Component {...field} {...form} {...meta} {...props} />
  );
  WithFieldComponent.displayName = 'withField';
  return WithFieldComponent;
};
